import api from '../api';
import { GATEWAYS } from '../components/payment-gateway/utils';
import {
    AUTOMATED_PAYMENT_PROPERTIES_ENDPOINT,
    AUTOMATED_PAYMENT_SETTINGS_ENABLED_ENDPOINT,
    AUTOMATED_PAYMENT_SETTINGS_ENDPOINT,
    PAYMENT_GATEWAY_DATA_ENDPOINT,
} from '../endpoints';

export default {
    namespaced: true,
    state() {
        return {
            paymentGatewayData: {},
            paymentTypes: {},
            logs: [],
            originalPaymentGatewayData: {},
            originalPaymentTypes: {},
            automatedPaymentSettings: {},
            propertiesOptions: [],
            paymentOrder: [],
        };
    },
    getters: {
        paymentGatewayData: state => state.paymentGatewayData,
        originalPaymentGatewayData: state => state.originalPaymentGatewayData,
        logs: state => state.logs,
        paymentTypes: state => state.paymentTypes,
        automatedPaymentSettings: state => state.automatedPaymentSettings,
        propertiesOptions: state => state.propertiesOptions,
        originalPaymentTypes: state => state.originalPaymentTypes,
        paymentOrder: state => state.paymentOrder,
    },
    mutations: {
        gotPaymentGatewayData(state, value) {
            state.paymentGatewayData = value;
        },
        gotOriginalPaymentGatewayData(state, value) {
            state.originalPaymentGatewayData = value;
        },
        gotLogs(state, value) {
            state.logs = value;
        },
        gotPaymentTypes(state, value) {
            state.paymentTypes = value;
        },
        gotOriginalPaymentTypes(state, value) {
            state.originalPaymentTypes = value;
        },
        gotPaymentOrder(state, value) {
            state.paymentOrder = value;
        },
        gotPropertiesOptions(state, value) {
            state.propertiesOptions = value;
        },
        gotAutomatedPaymentSettings(state, value) {
            state.automatedPaymentSettings = value;
        },
    },
    actions: {
        async fetchPaymentGatewayData({ commit }) {
            const { data } = await api.get(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}payment-gateway-data/`);
            const paypalGateway = GATEWAYS.find(item => item.key === 180);
            data.gateway.paypal_details = data.gateway.paypal_details || paypalGateway.defaultValues.paypal_details;
            data.gateway.paypal_auto_approve_payments = data.gateway.paypal_auto_approve_payments
                ? data.gateway.paypal_auto_approve_payments === 'True'
                : false;
            commit('gotPaymentGatewayData', JSON.parse(JSON.stringify(data)));
            commit('gotOriginalPaymentGatewayData', JSON.parse(JSON.stringify(data)));
            return data;
        },
        async fetchLogs({ commit }) {
            const { data } = await api.get(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}logs/`);
            commit('gotLogs', data);
        },
        async fetchPaymentTypes({ commit }) {
            const { data } = await api.get(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}payment-types/`);
            commit('gotPaymentTypes', data);
            commit('gotOriginalPaymentTypes', data);
        },
        async fetchPaymentOrder({ commit }) {
            const { data } = await api.get(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}payment-order/`);
            commit('gotPaymentOrder', data);
        },
        async fetchAutomatedPaymentSettings({ commit }) {
            const { data } = await api.get(AUTOMATED_PAYMENT_SETTINGS_ENDPOINT());
            commit('gotAutomatedPaymentSettings', data);
        },
        async fetchProperties({ commit }) {
            const { data } = await api.get(AUTOMATED_PAYMENT_PROPERTIES_ENDPOINT());
            const propertiesOptions = data.map(item => {
                return { value: item.property_id, text: item.name };
            });
            commit('gotPropertiesOptions', propertiesOptions);
        },
        async savePaymentGatewayData(_, values) {
            await api.post(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}save-payment-gateway-data/`, values);
        },
        async savePaymentTypesData(_, values) {
            await api.post(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}set-payment-types/`, values);
        },
        async saveAutomatedPaymentSettings(_, values) {
            await api.patch(AUTOMATED_PAYMENT_SETTINGS_ENDPOINT(), values);
        },
        async updateAutomatedPaymentSettingsEnabled(_, enabled) {
            await api.post(AUTOMATED_PAYMENT_SETTINGS_ENABLED_ENDPOINT(), { 'enabled': enabled });
        },
        async setPaymentOrder(_, values) {
            await api.post(`${PAYMENT_GATEWAY_DATA_ENDPOINT()}set-payment-order/`, values);
        },
    },
};
